import { Component, Input } from '@angular/core';
import {
	NavController,
    NavParams, 
    ToastController} from 'ionic-angular';
import { Organization } from '../../../../model/organization';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { ReportsService } from '../../../../services/reports.service';
import { ActionSheetController } from 'ionic-angular';
import { Horse } from '../../../../model/horse';

@Component({
	selector: 'page-offspring-nomination-report',
	templateUrl: 'report-offspring-nominations.html'
	
})
export class OffspringNominationReport {
    @Input('organization') organization: Organization;

    selectedStallion: Horse;
    showContactInfo: boolean = false;

    documentTitle: any;

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    constructor(
        private nav: NavController, 
        navParams: NavParams, 
        private reportService: ReportsService, 
        public actionSheetCtrl: ActionSheetController,
        private toast: ToastController
    ) {
        if (!this.organization)
            this.organization = navParams.get('organization');

        this.selectedStallion = navParams.get('selectedStallion');

        this.printing = navParams.get('printing');

        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        if (!this.selectedStallion && this.organization.nominations.length > 0)
            this.selectedStallion = this.organization.nominations[0].horseNominationSlots[0].horse;

        if (this.selectedStallion)
            this.documentTitle = this.selectedStallion.name + " - " + 'Offspring';
        
        this.dataLoaded = true;
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    ionViewDidEnter() {
        if (this.printing) {
            setTimeout(() => {
                window.document.title = this.documentTitle;
                window.print();
                this.nav.pop(); 
            }, 0);
        }
    }

    async downloadEquistat(rodeoEvent: RodeoEvent)  {
        await this.reportService.getEquistatReport(rodeoEvent.displayName, [rodeoEvent.id], true, false);
    }

    /*
    presentActionSheet() {
        const actionSheet = this.actionSheetCtrl.create({
          title: 'Select a report',
          buttons: [
            {
              text: '',
              handler: () => {
                if (this.selectedRodeoEvent) {
                    this.downloadEquistat(this.selectedRodeoEvent).then(() => {});
                } else {
                    this.toast.create({message: 'You must select an event.', position: 'bottom', duration: 2500}).present();
                }
              }
            },{
              text: 'QuickBooks Import',
              handler: () => {
                this.printQuickBooksImport();
              }
            },{
              text: 'Cancel',
              role: 'cancel'
            }
          ]
        });
        actionSheet.present();
    }
    */

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        this.nav.push(OffspringNominationReport, {
            organization: this.organization,
            printing: true,
            selectedStallion: this.selectedStallion,
            showContactInfo: this.showContactInfo
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/reports/report-offspring-nominations.ts